import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { BootstrapGate } from '@/config/BootstrapGate';
import { router } from '@/router';
import { AppThemeProvider } from '@/theme';
// Side-effect imports: i18next initialization and the self-hosted fonts.
import '@/i18n/i18n';
import '@/theme/fonts';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppThemeProvider>
      <BootstrapGate>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </BootstrapGate>
    </AppThemeProvider>
  </StrictMode>,
);
